import gql from 'graphql-tag';

const ARCHIVES_CLASSROOM = gql`
  mutation archiveClassrooms($where: ClassroomsWhereInput!) {
    archiveClassrooms(where: $where) {
      count
    }
  }
`;

export default ARCHIVES_CLASSROOM;
